import { getInputFocusStyle } from '@fluentui/react';
export function getBasePickerStyles(props) {
    var theme = props.theme, isFocused = props.isFocused, disabled = props.disabled;
    var focusBorderColor = (theme === null || theme === void 0 ? void 0 : theme.semanticColors.inputFocusBorderAlt)
        ? theme === null || theme === void 0 ? void 0 : theme.semanticColors.inputFocusBorderAlt
        : '#0f6cbd';
    var focusBorderRadius = (theme === null || theme === void 0 ? void 0 : theme.effects.roundedCorner4) ? theme === null || theme === void 0 ? void 0 : theme.effects.roundedCorner4 : 4;
    var styles = {
        text: [
            { borderRadius: theme === null || theme === void 0 ? void 0 : theme.effects.roundedCorner4 },
            isFocused && !disabled && getInputFocusStyle(focusBorderColor, focusBorderRadius),
        ],
    };
    return styles;
}
//# sourceMappingURL=BasePicker.styles.js.map